import Phaser from "phaser";
import {
  TILES_BY_SCREEN,
  TILE_SIZE,
  TICK_TIME,
  SCALE,
  SCALE_V,
} from "../utils/constants";
import LevelManager from "../components/LevelManager";
import Rules from "../components/Rules";
import UI from "../components/UI";
import CRTFilter from "../utils/CRTShaderFX";
import LevelTest from "../components/levels/level_ki_finale";
import { stopGlobalScore, stopResumeScore } from "../utils/globalScore";

export default class GameScene extends Phaser.Scene {
  constructor() {
    super("GameScene");
  }

  create(data = {}) {
    stopGlobalScore(this)
    stopResumeScore(this)
    this.cameras.main.setPostPipeline(CRTFilter);
    this.data.set("custom_scale", SCALE);
    this.isRestart = data.isRestart;

    this.game.scale.scaleMode = Phaser.Scale.RESIZE;
    this.handleScales();
    this.createAnimations();
    this.ui = new UI(this, data.levelName === LevelTest.key);
    if (this.levels?.current) {
      this.levels.current.cleanLevel();
    }
    this.levels = new LevelManager(this, data.levelName, data.isRestart);

    this.cameras.main.fadeIn(1000, 0, 0, 0);
    this.rules = new Rules(this);
    this.events.on(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.rules.destroy();
      this.ui.destroy();
    });
  }

  navigateToScene(sceneId, props = {}) {
    this.cameras.main.fade(500, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.rules.destroy();
      this.ui.destroy();
      if (this.levels?.current) {
        this.levels.current.cleanLevel();
        this.levels.current.destroy();
      }
      this.scene.start(sceneId, props);
    });
  }

  handleScales() {
    // const SCALE = this.data.get("custom_scale");
    // const scalables = new Map();
    // this.clearScalables = () => scalables.clear();
    // this.removeFromScalables = (el) => scalables.delete(el);
    // this.addToScalables = (el, coords) => {
    //   el.setScale(SCALE);
    //   scalables.set(el, coords);
    // };
    // this.updateScale = (scale) => {
    //   scalables.forEach((coords, el) => el?.setScale(scale));
    // };

    window.addEventListener("resize", () => {
      // const scale =
      //   Math.round(
      //     (((window.innerWidth / TILES_BY_SCREEN) * 100) / TILE_SIZE / 100) *
      //       100
      //   ) / 100;
      // const canvas = document.querySelector('canvas')
      // if(window.innerHeight > window.innerWidth) {
      //   canvas.height = 3 * window.innerWidth / 4
      // } else {
      //   canvas.width = 4 * window.innerHeight / 3
      // }
      this.children.list.forEach((ch) => {
        ch.setScale(SCALE, SCALE_V());
      });

      this.ui.onResize();

      const layer = this.children.getByName("layer_1");
      if (!layer) {
        return false;
      }
      this.levels?.current.updatePositionsOnScale();

      const camera = this.cameras.main;
      camera.setBounds(
        0,
        0,
        layer.width * layer.scaleX,
        layer.height * layer.scaleY
      );
    });
  }

  createAnimations() {
    this.anims.create({
      key: "boulder_roll_right",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [7, 10, 8, 7],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: 0,
    });
    this.anims.create({
      key: "boulder_roll_left",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [7, 8, 10, 7],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: 0,
    });
    this.anims.create({
      key: "diamond_roll_right",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [55, 56, 57, 60, 61, 62, 63, 54],
      }),
      frameRate: (1000 / TICK_TIME) * 8,
      repeat: 0,
    });
    this.anims.create({
      key: "diamond_roll_left",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [63, 62, 61, 60, 57, 56, 55, 54],
      }),
      frameRate: (1000 / TICK_TIME) * 8,
      repeat: 0,
    });
    this.anims.create({
      key: "boulder_idle",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [7] }),
      frameRate: 1,
      repeat: 0,
    });
    this.anims.create({
      key: "wall_torch_lit",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [12, 13, 14, 15, 16, 17],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: 0,
    });
    this.anims.create({
      key: "wall_torch_lighting",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [26, 27, 28, 29],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: 0,
    });
    this.anims.create({
      key: "wall_torch_idle",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [25] }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: 0,
    });
    this.anims.create({
      key: "barrel_idle",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [70] }),
      repeat: 0,
    });
    this.anims.create({
      key: "barrel_roll_right",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [71, 76, 77, 70],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "barrel_roll_left",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [77, 76, 71, 70],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "pillar_idle",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [66] }),
      frameRate: 1,
      repeat: 0,
    });
    this.anims.create({
      key: "pillar_roll_right",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [67, 68, 69, 66],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "pillar_roll_left",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [69, 68, 67, 66],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "liana_start",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [72] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "liana_middle",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [78] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "liana_end",
      frames: this.anims.generateFrameNumbers("boulder", { frames: [84] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "explosion_explode",
      frames: this.anims.generateFrameNumbers("explosion", {
        frames: [0, 1, 2, 3, 4, 5, 6, 7],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: 0,
    });

    this.anims.create({
      key: "diamond_idle",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [54],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: -1,
    });
    this.anims.create({
      key: "diamond_shine",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 58, 59, 64, 65,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
          53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53, 53,
        ],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: -1,
    });
    this.anims.create({
      key: "mushroom_idle",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [20] }),
      frameRate: 1,
      repeat: 0,
    });
    this.anims.create({
      key: "pickaxe_idle",
      frames: this.anims.generateFrameNumbers("pickables", { frames: [6] }),
      frameRate: 1,
      repeat: 0,
    });
    this.anims.create({
      key: "brave_idle",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 2, 2, 2, 2, 2, 2, 2, 0,
        ],
      }),
      frameRate: 4,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_idle_rockford",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [
          3, 3, 3, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 7, 5, 5, 6, 7, 5, 5, 5,
          6, 7, 5, 5, 6, 7, 5, 5, 5, 5, 5, 5, 5, 5, 6, 7, 5, 5, 6, 7, 5, 5, 5,
          6, 7, 5, 5, 6, 7, 5, 5, 5, 5, 5, 5, 5, 5, 6, 7, 5, 5, 6, 7, 5, 5, 5,
          6, 7, 5, 5, 6, 7, 5, 5, 5, 5, 5, 5, 5, 5, 6, 7, 5, 5, 6, 7, 5, 5, 5,
          4, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
        ],
      }),
      frameRate: 8,
      repeat: -1,
    });

    this.anims.create({
      key: "brave_idle_pickaxe",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [
          32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 33, 33, 33, 32, 34, 34, 34,
          34, 34, 34, 34, 32,
        ],
      }),
      frameRate: 4,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_run",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [8, 9, 10, 11, 12, 13, 14, 15],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5, // magic number that make smooth run and full frames in about 2 cycles
      repeat: -1,
    });
    this.anims.create({
      key: "brave_run_up",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [56, 57, 58, 59, 60, 61, 62, 63],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_run_pickaxe_up",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [56, 57, 58, 59, 60, 61, 62, 63],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_run_down",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [64, 65, 66, 67, 68, 69, 70, 71],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_run_pickaxe_down",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [72, 73, 74, 75, 76, 77, 78, 79],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_run_pickaxe",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [16, 17, 18, 19, 20, 21, 22, 23],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_break_pickaxe",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [40, 41, 41, 42, 43],
      }),
      frameRate: (1000 / TICK_TIME) * 5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_break_pickaxe_up",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [44, 45, 45, 46, 47],
      }),
      frameRate: (1000 / TICK_TIME) * 5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_break_pickaxe_down",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [52, 53, 53, 54, 55],
      }),
      frameRate: (1000 / TICK_TIME) * 5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_break_pickaxe_alt",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [48, 49, 49, 50, 51],
      }),
      frameRate: (1000 / TICK_TIME) * 5,
      repeat: -1,
    });
    this.anims.create({
      key: "brave_push",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [24, 24, 24, 24, 25, 26, 27],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: 0,
    });
    this.anims.create({
      key: "brave_dies",
      frames: this.anims.generateFrameNumbers("brave", {
        frames: [28, 29, 30, 31, 30, 31],
      }),
      frameRate: (1000 / TICK_TIME) * 3.5,
      repeat: 0,
    });
    this.anims.create({
      key: "torch_idle",
      frames: this.anims.generateFrameNumbers("torch", {
        frames: [0, 1, 2, 3],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "torch_run",
      frames: this.anims.generateFrameNumbers("torch", {
        frames: [8, 9, 10, 11, 12, 13, 14, 15],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "torch_run_up",
      frames: this.anims.generateFrameNumbers("torch", {
        frames: [56, 57, 58, 59, 60, 61, 62, 63],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "torch_run_down",
      frames: this.anims.generateFrameNumbers("torch", {
        frames: [64, 65, 66, 67, 68, 69, 70, 71],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "torch_push",
      frames: this.anims.generateFrameNumbers("torch", {
        frames: [24, 25, 26, 27, 24, 25, 26],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "torch_break_pickaxe",
      frames: this.anims.generateFrameNumbers("torch", {
        frames: [40, 41, 41, 42, 43],
      }),
      frameRate: (1000 / TICK_TIME) * 5,
      repeat: -1,
    });
    this.anims.create({
      key: "bat_move",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [18, 19, 20, 21, 22, 23, 24],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: -1,
    });
    this.anims.create({
      key: "ground_breaks",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "ground_disolves",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [32, 33, 34, 35, 36, 37, 38, 39, 40],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "jewel_pick",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [42, 43, 44, 45, 46, 40],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "enemy_dies",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [47, 48, 49, 50, 51, 52, 40],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });

    this.anims.create({
      key: "closeUp_Mary",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [0] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Marduk",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [1] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Dwarf",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [2] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Tiamat",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [5] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Pickaxe",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [6] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Mushroom",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [8] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Diamond",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [7] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Abushgidim",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [26] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_tentacles",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [27] }),
      repeat: 0,
    });
    // Bro
    this.anims.create({
      key: "bro_idle",
      frames: this.anims.generateFrameNumbers("bro", {
        frames: [
          0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 2, 2, 2, 2, 2, 2, 2, 0, 0, 0, 1, 1,
          1, 1, 1, 1, 0, 0, 0, 2, 2, 2, 0, 0, 1, 1, 1, 0,
        ],
      }),
      frameRate: 4,
      repeat: -1,
    });
    this.anims.create({
      key: "bro_run",
      frames: this.anims.generateFrameNumbers("bro", {
        frames: [8, 9, 10, 11, 12, 13, 14, 15],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5, // magic number that make smooth run and full frames in about 2 cycles
      repeat: -1,
    });
    this.anims.create({
      key: "bro_run_up",
      frames: this.anims.generateFrameNumbers("bro", {
        frames: [56, 57, 58, 59, 60, 61, 62, 63],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "bro_run_down",
      frames: this.anims.generateFrameNumbers("bro", {
        frames: [64, 65, 66, 67],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: -1,
    });
    this.anims.create({
      key: "bro_laying",
      frames: this.anims.generateFrameNumbers("bro", {
        frames: [31],
      }),
      frameRate: (1000 / TICK_TIME) * 3.5,
      repeat: 0,
    });
    // Shmebulock
    this.anims.create({
      key: "dwarf_idle",
      frames: this.anims.generateFrameNumbers("dwarf", {
        frames: [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 2, 2, 2, 2, 2, 2, 2, 0,
        ],
      }),
      frameRate: 4,
      repeat: -1,
    });
    this.anims.create({
      key: "dwarf_run",
      frames: this.anims.generateFrameNumbers("dwarf", {
        frames: [8, 9, 10, 11, 12, 13, 14, 15],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5, // magic number that make smooth run and full frames in about 2 cycles
      repeat: -1,
    });
    this.anims.create({
      key: "dwarf_run_up",
      frames: this.anims.generateFrameNumbers("dwarf", {
        frames: [56, 57, 58, 59, 60, 61, 62, 63],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "dwarf_look_up",
      frames: this.anims.generateFrameNumbers("dwarf", {
        frames: [57],
      }),
      frameRate: 1,
      repeat: -1,
    });
    this.anims.create({
      key: "dwarf_run_down",
      frames: this.anims.generateFrameNumbers("dwarf", {
        frames: [64, 65, 66, 67],
      }),
      frameRate: (1000 / TICK_TIME) * 4,
      repeat: -1,
    });
    this.anims.create({
      key: "exit_block",
      frames: this.anims.generateFrameNumbers("boulder", {
        frames: [0, 1, 2, 3, 4, 5],
      }),
      frameRate: (1000 / TICK_TIME) * 2.5,
      repeat: -1,
    });
    this.anims.create({
      key: "moonAltarTop",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [26] }),
      repeat: 0,
    });
    this.anims.create({
      key: "moonAltarBottom",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [37] }),
      repeat: 0,
    });
    this.anims.create({
      key: "sunAltarTop",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [27] }),
      repeat: 0,
    });
    this.anims.create({
      key: "sunAltarBottom",
      frames: this.anims.generateFrameNumbers("closeUpItems", { frames: [38] }),
      repeat: 0,
    });

    this.anims.create({
      key: "chunkHorizontalEven_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [0] }),
      repeat: -1,
    });
    this.anims.create({
      key: "chunkHorizontalOdd_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [10] }),
      repeat: -1,
    });
    this.anims.create({
      key: "chunkCurveEven_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [20] }),
      repeat: -1,
    });
    this.anims.create({
      key: "chunkCurveOdd_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [30] }),
      repeat: -1,
    });
    this.anims.create({
      key: "chunkHeadEven_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [70] }),
      repeat: -1,
    });
    this.anims.create({
      key: "chunkHeadOdd_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [60] }),
      repeat: -1,
    });

    this.anims.create({
      key: "chunkHorizontalEven_grow", // A
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [60, 61, 62, 63, 64, 0, 0, 0],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkHorizontalOdd_grow", // B
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [70, 71, 72, 73, 74, 10, 10, 10],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkCurveOdd_grow", // D
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [80, 81, 82, 83, 84],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkCurveEven_grow", // C
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [90, 91, 92, 93, 94],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkHeadEven_grow", // E
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [9, 9, 9, 50, 51, 52, 53, 70],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkHeadOdd_grow", // F
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [9, 9, 9, 40, 41, 42, 43, 60],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });

    // REDUCE
    this.anims.create({
      key: "chunkHeadEven_shrink", // E
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [70, 53, 52, 51, 50, 9],
      }),
      frameRate: (1000 / TICK_TIME) * 6,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkHeadOdd_shrink", // F
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [60, 43, 42, 41, 40, 9],
      }),
      frameRate: (1000 / TICK_TIME) * 6,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkHorizontalEven_shrink", // A
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [0, 0, 0, 64, 63, 62, 61, 60],
      }),
      frameRate: (1000 / TICK_TIME) * 6,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkHorizontalOdd_shrink", // B
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [10, 10, 10, 74, 73, 72, 71, 70],
      }),
      frameRate: (1000 / TICK_TIME) * 6,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkCurveOdd_shrink", // D
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [85, 85, 84, 83, 82, 81, 80],
      }),
      frameRate: (1000 / TICK_TIME) * 6,
      repeat: 0,
    });
    this.anims.create({
      key: "chunkCurveEven_shrink", // C
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [95, 95, 94, 93, 92, 91, 90],
      }),
      frameRate: (1000 / TICK_TIME) * 6,
      repeat: 0,
    });

    this.anims.create({
      key: "bossCenterTop",
      frames: this.anims.generateFrameNumbers("boss", { frames: [6] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossCenterMid",
      frames: this.anims.generateFrameNumbers("boss", { frames: [16] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossCenterBottom",
      frames: this.anims.generateFrameNumbers("boss", { frames: [26] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });

    this.anims.create({
      key: "bossSideTop",
      frames: this.anims.generateFrameNumbers("boss", { frames: [7] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossSideMid",
      frames: this.anims.generateFrameNumbers("boss", { frames: [17] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossSideBottom",
      frames: this.anims.generateFrameNumbers("boss", { frames: [27] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });

    this.anims.create({
      key: "bossBorderTop",
      frames: this.anims.generateFrameNumbers("boss", { frames: [8] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossBorderMid",
      frames: this.anims.generateFrameNumbers("boss", { frames: [18] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossBorderBottom",
      frames: this.anims.generateFrameNumbers("boss", { frames: [28] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });

    this.anims.create({
      key: "bossWombTop",
      frames: this.anims.generateFrameNumbers("boss", { frames: [45] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossWombBottom1",
      frames: this.anims.generateFrameNumbers("boss", { frames: [44] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossWombBottom2_idle",
      frames: this.anims.generateFrameNumbers("boss", { frames: [54] }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });

    this.anims.create({
      key: "bossWombBottom2_birth",
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [54, 55, 56, 57, 57, 58, 58, 59],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
    this.anims.create({
      key: "bossWombBottom2_blocked",
      frames: this.anims.generateFrameNumbers("boss", {
        frames: [54, 55, 56, 57, 56, 57, 56, 57, 56, 55],
      }),
      frameRate: (1000 / TICK_TIME) * 3,
      repeat: 0,
    });
  }
}
